<!--Rss-->

<template>
  <div class="tool-rss">
    <img class="field-media" src="@/assets/images/program/program_Rss_img.png" alt />
  </div>
</template>

<script>
export default {
  name: "ToolRss"
}
</script>

<style lang="scss" scoped>
.tool-rss {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .field-media {
    width: 100%;
    height: 100%;
    pointer-events: none;
    object-fit: contain;
  }
}
</style>